import { URLX, currentUrl, isInternalUrl, relativeUrl } from '@avensia/excite';

export const linkUrlSpaDataAttribute = 'data-nn-spa-url';
export function linkUrlDecorator(url: URLX, link: HTMLAnchorElement) {
  const newUrl = link?.getAttribute(linkUrlSpaDataAttribute);
  return newUrl && isInternalUrl(newUrl, currentUrl()) ? new URLX(relativeUrl(new URLX(newUrl), currentUrl())) : url;
}

function clickedLink(e: Event) {
  let target: HTMLElement | null = e.target as HTMLElement;
  do {
    if (target.tagName === 'A') {
      return target as HTMLAnchorElement;
    }
    // tslint:disable-next-line no-conditional-assignment
  } while ((target = target.parentElement));
  return undefined;
}

function globalLinkUrlDecorator(e: MouseEvent) {
  const link = clickedLink(e);
  const url = link?.getAttribute(linkUrlSpaDataAttribute);

  if (link && url && window?.event && (window.event as any).ctrlKey) {
    e.preventDefault();
    window.open(url, '_blank');
  }
}

if (__BROWSER__) {
  document.addEventListener('click', globalLinkUrlDecorator);
}

export function linkWithoutQueryParams(link: Partial<NordicNest.Api.NordicNestLinkApiModel>) {
  const { showQueries, ...linkAttributes } = link ?? {};
  const toUrl =
    link?.to && isInternalUrl(link.to, currentUrl()) ? relativeUrl(new URLX(link.to), currentUrl()) : link?.to;

  return showQueries ? linkAttributes : { ...linkAttributes, [linkUrlSpaDataAttribute]: link.to, to: toUrl };
}
